import { Model } from '@joelssonbygg/shared/types/Model'
import { collection } from 'firebase/firestore'
import { getDb } from '../firebase/firebase'
import { typeTransformer } from './typeTransformer'

export function typedCollection<T extends Model>(collectionName: string) {
  const db = getDb()
  return collection(db, collectionName).withConverter<T>(typeTransformer())
}
